export const ADV_ROUND = 3;

export const GameState = {
    status: null,
    score: 0,
    level: 1,
    timeLeft: 0,
    rows: 8,
    cols: 8,
    timeLimit: 120,
    selectedTile: null,
    hintPath: null,
    lastConnection: null,
    hintCount: 3,
    shuffleCount: 3,
}

export const EMOJI_SETS = [
  // 水果类（颜色对比强）
  ['🍎', '🍋', '🍌', '🍉', '🍇', '🍒', '🍑', '🍍', '🥝', '🍐', '🥥', '🍊', '🍈', '🥭', '🍓', '🍯'],

  // 动物类（形状差异大）
  ['🐶', '🐱', '🐭', '🐹', '🐰', '🐻', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐙', '🦊'],

  // 交通类（外形差大量级差异）
  ['🚗', '🚌', '🚓', '🚑', '🚒', '🚜', '🚲', '🛵', '🏍️', '🚂', '🚁', '🚀', '🚤', '🚢', '✈️', '🛸'],

  // 自然类（颜色与形状区分明显）
  ['🌍', '🌛', '☀️', '⭐', '☁️', '🔥', '💧', '❄️', '🌈', '⚡', '🌳', '🌵', '🌻', '🍁', '🌙', '🌊']
];

export const GameStatus = {
  PLAYING: 'PLAYING',
  WON: 'WON',
  LOST: 'LOST',
  MENU: 'MENU'
}

export const SOUND_FREQUENCIES = {
  SELECT: 440,
  MATCH: 880,
  FAIL: 220,
  LEVEL_UP: 1200
};
